<template>
  <div class="addFBoy container h-100">
    <div class="content">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>基础资料</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: 'favouriteBoy' }" replace>红人资料</el-breadcrumb-item>
        <el-breadcrumb-item>{{ type == 'add' ? '添加红人' : '编辑红人' }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="formCon">
        <el-form :model="addFBoy" class="form" :rules="rules" ref="ruleForm" label-width="100px">
          <el-row>
            <!-- <el-col :span="10">
                <el-form-item label="编号" prop="yid">
                    <el-input class="el-input-c-m" v-model="addFBoy.yid" placeholder="请输入红人编号"></el-input>
                </el-form-item>
            </el-col> -->
            <el-col :span="10">
              <el-form-item label="红人昵称" required>
                <el-input class="el-input-c-m" v-model="addFBoy.nickname"
                          placeholder="请输入红人昵称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="性别">
                <el-radio-group v-model="addFBoy.sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="经纪人" prop="agent_name">
                <UserSearch class="el-input-c-m" @handleSelect="changeAgent" v-if="isShowUserSearch"/>
                <el-input class="el-input-c-m" readonly placeholder="经纪人" v-model="addFBoy.agent_name" v-else>
                  <el-button slot="append" icon="el-icon-edit" @click="showUserSearch"></el-button>
                </el-input>
                <!--                <el-select class="el-input-c-m" v-model="addFBoy.agent_id" placeholder="请选择经纪人"-->
                <!--                           clearable filterable @change="handleAgentChange">-->
                <!--                  <el-option v-for="agent in agentOptions" :key="agent.value" :label="agent.label"-->
                <!--                             :value="agent.value"></el-option>-->
                <!--                </el-select>-->
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="省/市">
                <el-cascader class="el-input-c-m" size="large" :options="options"
                             v-model="selectedOptions" @change="handleRegionChange"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="红人标签">
                <template v-if="JSON.stringify(targets) != '{}'">
                  <el-checkbox-group v-model="addFBoy.target">
                    <el-checkbox v-for="target in targets" :key="target" :label="target"
                                 border></el-checkbox>
                  </el-checkbox-group>
                </template>
                <template v-else>暂无</template>
              </el-form-item>
            </el-col>
          </el-row>
          <template v-for="(plat, index) in addFBoy.platforms">
            <el-row :key="index">
              <el-col :span="20">
                <el-form-item label="">
                  <div class="plat-item">
                    <div class="plat-header">
                      <div class="h-l"><i class="el-icon-plat"></i>平台{{ index + 1 }}</div>
                      <div class="h-r"><i class="el-icon-close"
                                          @click='closePlat(index, plat)'></i>
                      </div>
                    </div>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="平台" :prop="'platforms.' + index + '.platform'"
                                      :rules="{ required: true, message: '请选择平台', trigger: 'change' }">
                          <el-select v-model="plat.platform" placeholder="请选择平台">
                            <el-option v-for="(platform, key) in platforms" :key="key"
                                       :label="`${key}`" :value="key">
                              <span style="float: left">{{ key }}</span>
                              <span
                                  style="float: right; color: #8492a6; font-size: 13px">{{
                                  platform
                                }}</span>
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="平台ID" :prop="'platforms.' + index + '.uid'"
                                      :rules="{ required: false, message: '请输入平台ID', trigger: 'blur' }">
                          <el-input class="el-input-c-m" v-model="plat.uid"
                                    placeholder="请输入平台ID" maxlength="191"
                                    show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="粉丝数量(W)" :prop="'platforms.' + index + '.fans_num'"
                                      :rules="{ required: false, message: '请输入数字', trigger: 'blur' }">
                          <el-input class="el-input-c-m" v-model.trim="plat.fans_num"
                                    placeholder="请输入粉丝数量" maxlength="11" show-word-limit/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12" v-if="userAuth.can_see_artist_info_col_rate">
                        <el-form-item label="分成比例(%)" :prop="'platforms.' + index + '.rate'"
                                      :rules="{ required: true, message: '请输入分成比例', trigger: 'blur' }">
                          <!-- <el-input class="el-input-c-m" v-model="plat.rate" :min="0" :max="100" placeholder="请输入分成比例" maxlength="6" show-word-limit></el-input> -->
                          <el-input-number class="el-input-t-l el-input-c-m"
                                           v-model="plat.rate" :min="0" :max="100" :precision="2"
                                           :controls="false" controls-position="right"
                                           placeholder="请输入分成比例"></el-input-number>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <!--                                        <el-row>-->
                    <!--                                            <el-col :span="24">-->
                    <!--                                                <el-form-item label="个人主页">-->
                    <!--                                                    <el-input class="el-input-c-l" v-model="plat.home_page" placeholder="请输入个人主页" maxlength="191" show-word-limit></el-input>-->
                    <!--                                                </el-form-item>-->
                    <!--                                            </el-col>-->
                    <!--                                        </el-row>-->
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <el-row>
            <el-col :span="24">
              <el-form-item label="">
                <!-- <el-button type="primary" plain icon="el-icon-circle-plus-outline" @click="addPlat">添加更多平台</el-button> -->
                <div @click="addPlat" class="funcbars-addbutton d-flex-row align-items-center"
                     style="display:inline-block;padding:0 15px;">
                  <i class="el-icon-circle-plus-outline"></i>
                  添加更多平台
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="备注">
                <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="addFBoy.remark"
                          maxlength="191" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:60px;">
            <el-col :span="20">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="报价">
                    <template v-if="JSON.stringify(bj_items) != '{}'">
                      <el-checkbox-group v-model="addFBoy.platform_bj" @change="onBjChange">
                        <el-checkbox v-for="bj in bj_items" :key="bj" :label="bj"
                                     border></el-checkbox>
                      </el-checkbox-group>
                    </template>
                    <template v-else>暂无</template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="">
                    <el-table :data="tableData" stripe style="width:80%;margin-bottom: 100px">
                      <el-table-column class="table-header" prop="name"
                                       label="合作模式"></el-table-column>
                      <el-table-column class="table-header" label="报价（¥）">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.price" style="width:100px;"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column class="table-header" label="操作">
                        <template slot-scope="scope">
                          <a href="javascript:;" style="color:#323232"
                             @click="deleteBj(scope)">删除</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <div class="formCon-buttons">
            <el-row style="text-align:center">
              <el-col :push="5" :span="8">
                <button-submit ref="buttonSubmit" :button-txt="type === 'edit' ? '保存' : '添加'"
                               style="padding:10px 30px" @click.native.prevent="submitValidate('ruleForm')"
                               v-if="userAuth.can_update_artist_info"/>
              </el-col>
              <el-col :push="2" :span="8">
                <el-button @click="goBack">返回</el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>

    </div>
  </div>
</template>
<script>
import {CodeToText, provinceAndCityData, TextToCode} from 'element-china-area-data'
import {addOrEditFBoy, getFBoyDetail, platformDelete} from '../../api/fboy'
import {getOptionItems} from '../../api/option'
import {optionsUsers} from '../../api/adOrder'

const statusMap = {
  'GT': '洽谈中',
  'SH': '待审核',
  'QY': '已签约',
  'QM': '已期满',
  'KX': '空闲中'
}
export default {
  name: 'addFBoy',
  data() {
    return {
      statusMap,
      dialogTableVisible: false,//弹窗是否显示
      isShowUserSearch: false,//显示经纪人编辑框
      addFBoy: {
        // yid: '',
        nickname: '', //红人名称
        agent_name: '', //经纪人名称
        agent_id: '', //经纪人ID
        sex: 1,
        province: '',
        city: '',
        target: [],
        platforms: [
          {
            platform: '', //平台名称
            fans_num: '',
            rate: '0',
            home_page: '',
            uid: ''
          }
        ],
        remark: '',
        platform_bj: []
      },
      rules: {
        // yid: [
        //     { required: true, message: '请输入红人编号', trigger: 'blur' },
        // ],
        agent_name: [
          {required: true, message: '请输入经纪人', trigger: 'blur'},
        ],
        platform: [
          {required: true, message: '请选择平台', trigger: 'change'},
        ],
        uid: [
          {required: true, message: '请输入平台ID', trigger: 'blur'},
        ],
        rate: [
          {required: true, message: '请输入分成比例', trigger: 'blur'},
        ],
        fans_num: [
          {message: '请输入数字', trigger: 'blur,change'}
        ]

      },
      platforms: {}, //平台
      bj_items: {}, //平台报价
      targets: {}, //红人标签
      agentOptions: [], //经纪人选项
      options: provinceAndCityData,
      selectedOptions: [],
      tableData: [],
      type: '',// add or edit
      id: '',//详情id
      optionsItem: ['targets', 'platforms', 'bj_items'],

      //弹窗列表
      infoForm: {
        nickname: '', //红人名称
        agent_name: '', //经纪人名称
      },
      params: {
        page: 1,
        per_page: 10,
        total: 100,
      },
      theadData: [],
      fboyData: [],
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.$route.query.type) this.type = this.$route.query.type
      if (this.type === 'add') {
        this.isShowUserSearch = true
      }
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.getFBoyDetail(this.$route.query.id)
      }

      this.getOptions(this.optionsItem)
      this.getAgentOptions()
    },
    addPlat() {
      let plat = {
        platform: '', //平台名称
        fans_num: '',
        rate: '0',
        home_page: '',
        uid: ''
      }
      this.addFBoy.platforms.push(plat)
    },
    closePlat(index, plat) {
      const that = this
      that.showModal({
        h: that,
        text: "删除后不可修复，确定删除吗？",
        confirm: function () {
          if (plat && plat.id) {
            platformDelete({
              id: plat.id,
            }).then(() => {
              that.addFBoy.platforms.splice(index, 1)
            })
          } else {
            that.addFBoy.platforms.splice(index, 1)
          }
        }
      });
    },
    deleteBj(scope) {
      let index = scope.$index
      this.tableData.splice(index, 1)
      let name = scope.row.name
      let platform_bj = this.addFBoy.platform_bj
      for (var i = 0; i < platform_bj.length; i++) {
        if (name == platform_bj[i]) {
          platform_bj.splice(i, 1)
        }
      }
      this.addFBoy.platform_bj = platform_bj
    },
    onBjChange(e) {
      let tableData = JSON.stringify(this.tableData)
      tableData = JSON.parse(tableData) || []
      this.tableData = this.tableData || []
      if (e.length) {
        if (Array.isArray(tableData) && tableData.length) {
          if (tableData.length > e.length) { // table > e
            for (var k = 0; k < tableData.length; k++) {
              var isExist = false
              var temp = ''
              for (var i = 0; i < e.length; i++) {
                if (e[i] == tableData[k].name) {
                  isExist = true
                  temp = e[i]
                  break;
                }
              }
              if (!isExist) {
                this.tableData.splice(k, 1)
                break
              }
            }
          } else { //e > table
            // eslint-disable-next-line
            for (var k = 0; k < tableData.length; k++) {
              // eslint-disable-next-line
              var isExist = true
              // eslint-disable-next-line
              var temp = ''
              // eslint-disable-next-line
              for (var i = 0; i < e.length; i++) {
                if (e[i] != tableData[k].name) {
                  isExist = false
                  temp = e[i]
                }
              }
              if (!isExist) {
                var obj = {
                  name: temp,
                  price: ''
                }
                this.tableData.push(obj)
                break
              }
            }
          }

        } else {
          // eslint-disable-next-line
          for (var i = 0; i < e.length; i++) {
            // eslint-disable-next-line
            var obj = {
              name: e[i],
              price: ''
            }
            this.tableData.push(obj)
          }
        }
      } else {
        this.tableData = []
      }
    },
    getOptions(options) {
      getOptionItems(options).then(res => {
        this.platforms = res.model.platforms || {}
        this.bj_items = res.model.bj_items || {}
        this.targets = res.model.targets || {}
      })
    },
    // 获取经纪人选项
    getAgentOptions() {
      optionsUsers().then(res => {
        this.agentOptions = res.model || []
      }).catch(() => {
        this.agentOptions = []
      })
    },
    handleRegionChange(e) {
      this.addFBoy.province = CodeToText[e[0]]
      this.addFBoy.city = CodeToText[e[1]]
    },
    changeAgent(val) {
      if (val.id) {
        this.addFBoy.agent_name = val.name
        this.addFBoy.agent_id = val.id
        this.isShowUserSearch = false
      }

    },
    showUserSearch() {
      this.isShowUserSearch = !this.isShowUserSearch
      if (this.isShowUserSearch) {
        this.addFBoy.agent_name = ''
        this.addFBoy.agent_id = 0
      }
    },
    // 处理经纪人选择
    handleAgentChange(agentValue) {
      if (agentValue) {
        const selectedAgent = this.agentOptions.find(agent => agent.value === agentValue)
        if (selectedAgent) {
          this.addFBoy.agent_name = selectedAgent.label
          this.addFBoy.agent_id = selectedAgent.value
        }
      } else {
        // 清空时重置经纪人名称和ID
        this.addFBoy.agent_name = ''
        this.addFBoy.agent_id = ''
      }
    },
    onSubmit() {
      this.getFBoyList(this.addFBoy)
    },
    getFBoyDetail(id) {
      getFBoyDetail(id).then(res => {
        let temp = res.model
        this.tableData = res.model.platform_bj
        let arr = []
        if (temp.platform_bj) {
          temp.platform_bj.forEach(item => {
            arr.push(item.name)
          })
        }
        temp.platform_bj = arr
        if (temp.target && temp.target.length) {
          temp.target = temp.target.split(',')
        } else {
          temp.target = []
        }
        this.addFBoy = temp
        // 确保经纪人下拉选项正确回显
        if (temp.agent_id) {
          this.addFBoy.agent_id = temp.agent_id
        }
        if (res.model.province && res.model.city) {
          let province = TextToCode[res.model.province].code
          let city = TextToCode[res.model.province][res.model.city].code
          this.selectedOptions = [province, city]
        }
      })
    },
    submitValidate(formName) {
      let that = this
      if (!that.addFBoy.nickname) {
        that.showToast({
          h: that,
          icon: 'el-icon-warning',
          text: '红人昵称未填写！'
        })
        return false
      }
      // eslint-disable-next-line no-unused-vars
      this.$refs[formName].validate((valid, errors) => {
        if (valid) {
          let addFBoy = JSON.stringify(that.addFBoy)
          addFBoy = JSON.parse(addFBoy)
          addFBoy.platform_bj = that.tableData
          addOrEditFBoy(addFBoy).then(res => {
            that.showToast({
              h: that
            })
            if (that.type === 'add') {
              setTimeout(() => {
                that.$router.push({
                  name: `addFBoy`,
                  query: {type: "edit", id: res.model.id}
                });
                that.init()
              }, 1500)
            } else {
              that.init()
            }
          })
        } else {
          // console.log(valid)
          // console.log(errors)
          that.showToast({
            h: that,
            icon: 'el-icon-warning',
            text: '有必填项未填写！'
          })
          return false;
        }
      });
    },
    goBack() {
      this.$router.back()
    },
    checkNumber(row, digit = 1) {
      let value = row.fans_num
      value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
      value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      switch (digit) {
        case 4:
          // eslint-disable-next-line
          value = value.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3'); //只能输入四位小数
          break;
        case 2:
          // eslint-disable-next-line
          value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
          break;
        default:
          // eslint-disable-next-line
          value = value.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'); //只能输入两个小数
          break;
      }
      if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      row.fans_num = value
      return value
    }
  }
}
</script>
<style scoped>
.content {
  background: #fff;
  padding: 24px 30px 0;
}

.formCon {
  margin: 40px auto 0px auto;
  width: 80%;
}


div.el-input-c {
  width: 50%;
}

div.el-input-c-m {
  width: 80%;
}

div.el-input-c-l {
  width: 91%;
}

.plat-item {
  padding: 24px;
  border-radius: 4px;
  border: 1px solid rgba(221, 221, 221, 1);
}

.plat-item .plat-header {
  display: flex;
  justify-content: space-between;
}

.plat-item .plat-header .h-l {
  color: #E03F3D;
}

.plat-item .plat-header .h-r {
  font-size: 32px;
}

.formCon-buttons {
  left: 0px;
  bottom: 0px;
  width: 100%;
  background-color: #fff;
  box-shadow: -1px -4px 9px 0px rgba(195, 195, 195, 0.8);
  padding: 8px 0px;
  z-index: 10;
  position: fixed;
}
</style>
<style>
.el-form-item div.el-form-item__content {
  text-align: left;
}

.plat-item .el-form-item {
  margin-bottom: 20px;
}

.plat-item .el-select {
  width: 80%;
}

/* .el-table__header th.is-leaf{
        background:rgba(4,153,255,0.1);
        color:#323232;
        font-weight: 500;
        font-size: 14px;
    } */
div.el-dialog__header {
  text-align: left;
}

.el-input-t-l.el-input-number .el-input__inner {
  text-align: left;
}
</style>
